import BreadcrumbItem from './BreadcrumbItem';
import { BreadcrumbItemProps, BreadcrumbItemValueProps, BreadcrumbItemCombinedProps } from './types';

export type { BreadcrumbItemProps, BreadcrumbItemValueProps, BreadcrumbItemCombinedProps };
export default BreadcrumbItem;
